module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lumi-navigation"
  }, [_c('div', {
    class: _vm.className
  }, [_c('nav', {
    staticClass: "lumi-navbar-content",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._t("title"), _vm._v(" "), _c('div', {
    staticClass: "lumi-navbar-content-inner"
  }, [_vm._t("default")], 2)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "lumi-navbar-backdrop"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-24a70e5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LumiNavbar.vue
// module id = 60
// module chunks = 0